<div class="flex-column gap-2 f-1-0">
	<span>
		Create and manage email signatures for outbound emails. Signatures will be inserted at the bottom of the email body,
		and can be used by creating <a *ngIf="gs.userInfo.outboundAllowRules" class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.policyManagement, dic.CONSTANTS.outboundRulesAndPoliciesPageTabs.rules]">outbound rules</a><span *ngIf="!gs.userInfo.outboundAllowRules">outbound rules</span> with the "Insert Signature" action.
	</span>

	<div class="d-flex w-100 centralize" *ngIf="isFeatureEnabled === undefined">
		<loader height="100" width="100" style="opacity: 0.8;"></loader>
	</div>

	<div class="flex-row f-1-0 position-relative" style="flex-wrap: wrap; overflow: auto; gap: 14px;"
		 *ngIf="isFeatureEnabled !== undefined">
		<!-- list of signatures (left side) -->
		<div class="flex-column ms-0" style="flex: 0 1; margin: 7px; padding: 5px; min-width: 415px; min-height: 350px; background: linear-gradient(#163f5d1a, transparent, #a0a0a02e) , linear-gradient(74deg, #d3f1ff6b , transparent 51%, transparent);"
			 *ngIf="isFeatureEnabled">
			<div class="flex-column" style="flex: 1 0; overflow: auto;">
				<div class="w100 flex-row justify-content-between" style="background: #677184; padding: calc(3px + 0.4vw); align-items: center; z-index: 1; min-height: 42px;">
					<!-- Search -->
					<search-box [(model)]="searchSignatureTxt"
								(modelChange)="signaturesTableEl.searchItem()"
								placeholder="Search signature"
								style="min-width: 200px;">
					</search-box>
					<div style="padding-left: 20px; width: clamp(170px,10vw,210px);">
						<btn-c class="w100" style="background: white;"
							   variant="outlined" endIcon="far fa-plus"
							   [isDisabled]="getSignaturesInProcess || (activeSignature && !activeSignature._id)"
							   (action)="startAddNewSignature();">
							Create Signature
						</btn-c>
					</div>
				</div>
				<!-- table -->
				<trustifi-table-c
					class="trustifi-table short-action-column" style="flex: 1 0; z-index: 5; background: white;"
					#signaturesTableEl
					[list]="signatures"
					[headers]="[
						{text: 'Name', sortKey: 'name'}
					]"
					[cellsPrototype]="[
						{textKey: 'name', onClick: selectActiveSignature}
					]"
					[bulkActions]="{
						enable: true,
						selectBulkActionCb: selectMultipleSignaturesAction,
						initBulkActionsFunction: showSignatureBulkActions
					}"
					[cellActions]="{
						enable: true,
						selectItemActionCb: selectSignatureAction,
						initActionsFunction: showSignatureActions
					}"
					(searchFunction)="searchSignatures()"
					[options]="{
						loadingTableFlag: getSignaturesInProcess,
						soloSelected: true,
						itemUniqueIdentifier: '_id',
						hideContentAboveTable: true,
						itemsNameSingular: 'signature'
					}"
				>
				</trustifi-table-c>
			</div>
		</div>

		<!-- details area (right side) -->
		<div class="flex-row gap-2 me-0 flex-wrap justify-content-start" style="flex: 7 0; margin: 7px; min-width: 600px; background: #f7f7f7; position: relative; overflow: auto; padding: 10px;"
			 [ngClass]="{'align-items-center justify-content-center' : !activeSignature, 'disabled-overlay' : isFeatureEnabled === false}">
			<ng-container *ngIf="activeSignature">
				<div class="flex-column gap-3 w100" style="flex:1 0; overflow: auto; background: white; padding: 15px; min-width: 660px;"
					 *ngIf="activeSignature">
					<div class="flex-row gap-3 align-items-center">
						<span style="font-size: 14px;">
							Name:
							<i class="far fa-question-circle" style="font-weight: 400; margin-left: 4px;" tooltip="The signature name cannot be edited after the signature has been created"></i>
						</span>
						<input class="f-1-0" type="text" id="signatureNameInput"
							   (keyup)="isMissingName = false;"
							   [disabled]="activeSignature._id"
							   [ngClass]="{'validation-error' : isMissingName}"
							   [(ngModel)]="activeSignature.name">
						<!--CC: ready-made templates to start from. Only relevant before the signature is created-->
						<ng-container *ngIf="!activeSignature._id">
							<span style="font-size: 14px;">
								Template:
								<i class="far fa-question-circle" style="font-weight: 400; margin-left: 4px;" tooltip="Select a ready-made signature layout to start from. You may edit it afterwards"></i>
							</span>
							<app-dropdown-c style="width: 160px;"
											[items]="signatureTemplates"
											itemDisplayKey="name"
											(onItemClicked)="selectSignatureTemplate($event.item);"
											text="{{selectedSignatureTemplate?.name}}"></app-dropdown-c>
						</ng-container>
					</div>
					<div class="flxClmn email-signatures-summernote" id="summernoteContainer"
						 (dragenter)="toggleSummernoteDragState(true, $event)"
						 (dragleave)="toggleSummernoteDragState(false, $event)"
						 (dragend)="toggleSummernoteDragState(false, $event)">
						<div class="f-1-0 summernote-editor" id="summernote"
							 [ngxSummernote]="summernoteOptions"
							 [(ngModel)]="activeSignature.html"
							 (ngModelChange)="previewSignature()">
						</div>
					</div>

					<div class="flex-row justify-content-between gap-3 align-items-center">
						<div class="flex-row gap-2 align-items-enter">
							<div id="signaturesLoadHTML"
								 [(file)]="htmlFile"
								 ngfSelect
								 accept=".txt, .htm, .html, text/plain, text/html"
								 (fileChange)="loadHtml()">
								<btn-c style="width: 120px;"
									   color="#282828" variant="outlined"
									   startIcon="far fa-file-upload">
									Load HTML
								</btn-c>
							</div>
							<!--<btn-c style="width: 120px;" id="signaturesPreview" variant="outlined" color="#595959" (action)="previewSignature()">Preview</btn-c>-->
							<btn-c style="width: 120px;" id="signaturesExport"
								   color="#282828" variant="outlined"
								   startIcon="far fa-file-download" (action)="exportSignature()">
								Export
							</btn-c>
						</div>
						<div class="flex-row gap-2 align-items-enter">
							<btn-c id="signaturesSave"
								   [loading]="updateSignatureInProcess"
								   (action)="saveSignature()">
								{{activeSignature._id ? 'Update' : 'Save'}}
							</btn-c>
							<btn-c id="signaturesCancel" variant="text"
								   *ngIf="!activeSignature._id"
								   [isDisabled]="updateSignatureInProcess"
								   (action)="cancelAddNewSignature()">
								Cancel
							</btn-c>
						</div>
					</div>
				</div>

				<div class="flex-row flex-wrap justify-content-start gap-2 f-1-0" style="min-width: 410px; min-height: 300px; overflow: auto;">
					<div class="flex-column gap-4 bg-white p-3 shadow-sm f-1-0" style="min-height: 300px; min-width: 410px;">
						<span class="fw-500" style="font-size: 14px;">Signature Preview</span>
						<email-viewer style="overflow: auto; flex: 1 0; width: 100%; min-width: 220px; border: 1px solid #ccc;"
									  [content]="previewHtmlParsed || ''">
						</email-viewer>
					</div>
					<div class="flex-column gap-3 bg-white p-3 shadow-sm overflow-auto f-1-0" style="min-height: 300px; max-height: 370px; min-width: 410px;">
						<div class="flex-column gap-1 bg-white" style="position: sticky; top: 0; padding: 3px 0;">
							<div class="flex-row align-items-center">
								<span class="fw-500" style="font-size: 14px;">Templates dynamic fields</span>
								<span class="text-muted ms-3" style="font-size: 12px;">(Click each dynamic field to copy)</span>
							</div>
							<span>When the signature is sent within the email, the content inside these fields will be changed according to your settings</span>
						</div>

						<div class="flex-column gap-2 f-1-0 overflow-auto pe-2">
							<div class="flex-row gap-2 align-items-center"
								 *ngFor="let field of dic.CONSTANTS.templateDynamicFieldsForAdmin | keyvalue: gs.returnZero">
								<div class="border border-1 rounded-2 cursor-pointer hvr-opacity d-flex centralize py-1 px-2 copy-link flex-shrink-0"
									 style="flex-basis: 140px;"
									 (click)="copyDynamicField(field.key)">
									<span class="fw-500">{{field.key}}</span>
								</div>
								<span *ngIf="field.value.includes('%s')" [innerHTML]="util.format(field.value, lfPageUrl)"></span>
								<span *ngIf="!field.value.includes('%s')">{{field.value}}</span>
							</div>
						</div>
					</div>
				</div>
			</ng-container>

			<div *ngIf="!activeSignature" class="flex-column justify-content-center" style="align-items: center; flex: 1 0;">
				<i class="far hvr-opacity fa-file-signature" style="font-size: 4vw;  opacity: 0.1;"></i>
			</div>
		</div>

		<!--"feature not enabled" placeholder-->
		<div class="flex-column f-1-0 absolute-centralize rounded-2 bg-white border border-3 border-secondary text-center gap-2"
			 *ngIf="isFeatureEnabled === false"
			 style="align-items: center; overflow: auto; z-index: 1005; top: 40%; padding: 3rem; box-shadow: 0 7px 20px #ababab;">
			<i class="far fa-file-signature" style="font-size: 5rem; color: darkgray;"></i>
			<br/>
			<h3>Email Signatures</h3>
			<span style="font-size: 18px;">Create and manage email signatures for outbound emails</span>
			<br/>
			<span class="fw-500 mb-2" style="font-size: 18px;">This is a new <b>ALPHA</b> feature</span>
			<a class="blue-link text-decoration-underline" href="mailto:support@trustificorp.com" style="font-size: 18px;">Contact our team to enable this feature in your plan</a>
		</div>
	</div>
</div>

